module.exports = "/work-site/img/carType.cd718e85.png";